import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { IHttpProjects } from '../../models/http-models/http-projects';

@Injectable()
export class ProjectsService {
  url = `${environment.domain}/assets/data/projects.json`;

  constructor(private _http: HttpClient) {}

  getProjects(): Observable<IHttpProjects> {
    return this._http.get<IHttpProjects>(this.url);
  }
}
